module.exports = __webpack_public_path__ + "static/media/woman-looking-at-man.356ff46e.jpg";